import { useAdmin } from "@/hooks/use-admin";
import { Link } from "wouter";
import { Loader2 } from "lucide-react";

interface AdminLayoutProps {
  children: React.ReactNode;
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const { isAdmin, isLoading } = useAdmin();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (!isAdmin) {
    return null; // useAdmin hook will handle the redirect
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="border-b border-zinc-800">
        <div className="container mx-auto px-6">
          <div className="flex items-center h-14 gap-6">
            <Link href="/" className="font-semibold">
              <span className="text-red-600">Bitcoin</span>
              <span className="text-white">Puzzles</span>
            </Link>
            <nav className="flex gap-4">
              <Link href="/admin/stats" className="text-zinc-400 hover:text-white transition-colors">
                Stats
              </Link>
              <Link href="/admin/videos" className="text-zinc-400 hover:text-white transition-colors">
                Videos
              </Link>
              <Link href="/admin/users" className="text-zinc-400 hover:text-white transition-colors">
                Users
              </Link>
              <Link href="/admin/puzzles" className="text-zinc-400 hover:text-white transition-colors">
                Puzzles
              </Link>
              <Link href="/admin/faq" className="text-zinc-400 hover:text-white transition-colors">
                FAQ
              </Link>
              <Link href="/admin/codes" className="text-zinc-400 hover:text-white transition-colors">
                Codes
              </Link>
            </nav>
          </div>
        </div>
      </div>
      <main className="container mx-auto p-6">
        {children}
      </main>
    </div>
  );
}